import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, map, isEqual, indexOf } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { Button, Box, Modal, Typography, Stack } from '@mui/material';

import handleErrorInClient from '../../../../modules/handle-error-in-client';
import methodPromise from '../../../../modules/method-promise-wrapper';

import * as annotationOps from '../../../../api/Annotations/annotation-operations';
import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import AnnotationTemplatePreview from '../../AnnotationTemplatePreview';

const UpdateAnnotationMaps = props => {
  const {
    handleCloseUpdateEditor,
    selectedAnnotation,
    handleAnnotationDeleted,
    handleAnnotationUpdated
  } = props;

  const updateTemplate = annotationOps.getTemplate(selectedAnnotation);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [fieldsTemplate, setFieldsTemplate] = React.useState(updateTemplate);

  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  };

  const handleDeleteAnnotation = async () => {
    const annotationId = annotationOps.getId(selectedAnnotation);
    try {
      await methodPromise('annotations.hardDelete', annotationId);
      Bert.alert('Annotation deleted', 'success');
      handleAnnotationDeleted(selectedAnnotation);
      handleCloseUpdateEditor();
    } catch (e) {
      handleErrorInClient(e);
    }
  };

  const handleOpenModalDelete = () => {
    setOpenModalDelete(true);
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const handleSubmitUpdate = async () => {
    try {
      await methodPromise('annotations.update', selectedAnnotation);
      Bert.alert('Annotation updated', 'success');
      handleAnnotationUpdated(selectedAnnotation);
      handleCloseUpdateEditor();
    } catch (e) {
      handleErrorInClient(e);
    }
  };

  const updateAnnotationFields = (elementItem, property, newValue) => {
    const newFieldsTemplate = cloneDeep(fieldsTemplate);
    const templateElementsArray = templateOps.getElements(fieldsTemplate);
    const newElementTemplate = map(templateElementsArray, element => {
      const newElement = element;
      if (
        isEqual(
          indexOf(templateElementsArray, element),
          indexOf(templateElementsArray, elementItem)
        )
      ) {
        newElement[property] = newValue;
      }
      return newElement;
    });
    newFieldsTemplate.elements = newElementTemplate;
    setFieldsTemplate(newFieldsTemplate);
  };

  return (
    <>
      <AnnotationTemplatePreview
        annotationTemplate={fieldsTemplate}
        previewMode="edition"
        updateAnnotationFields={updateAnnotationFields}
        selectedAnnotation={selectedAnnotation}
        isNotesComponent
      />
      <Box display="flex" height="100px" width="100%">
        <Stack direction="row" alignItems="center">
          <Button variant="outlined" color="success" onClick={handleSubmitUpdate}>
            Actualizar
          </Button>
          <Button variant="outlined" color="warning" onClick={handleOpenModalDelete}>
            Borrar
          </Button>
          <Button variant="outlined" color="error" onClick={handleCloseUpdateEditor}>
            Cancelar
          </Button>
        </Stack>
      </Box>
      <Modal
        open={openModalDelete}
        onClose={handleCloseModalDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            La anotación será eliminada
          </Typography>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            ¿Está de acuerdo?
          </Typography>
          <Button variant="outlined" color="success" onClick={handleDeleteAnnotation}>
            Confirmar
          </Button>
          <Button variant="outlined" color="error" onClick={handleCloseUpdateEditor}>
            Cancelar
          </Button>
        </Box>
      </Modal>
    </>
  );
};

UpdateAnnotationMaps.defaultProps = {};

UpdateAnnotationMaps.propTypes = {
  handleCloseUpdateEditor: PropTypes.func.isRequired,
  selectedAnnotation: PropTypes.object.isRequired,
  handleAnnotationDeleted: PropTypes.func.isRequired,
  handleAnnotationUpdated: PropTypes.func.isRequired
};

export default UpdateAnnotationMaps;
